import moment from 'moment';

export const ageResolver = (cpr: string) => {
  if (cpr.length === 12) {
    const birthPart = cpr.slice(0, 8);
    return moment().diff(moment(birthPart, 'YYYYMMDD'), 'years');
  } else {
    let wholeValue;
    const birthPart = cpr.slice(0, 6);
    if (birthPart.slice(0, 2) >= moment().year().toString().slice(2, 4)) {
      wholeValue = '19'.concat(birthPart);
    } else wholeValue = '20'.concat(birthPart);
    return moment().diff(moment(wholeValue, 'YYYYMMDD'), 'years');
  }
};
